import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

function ImageCustom({
  url,
  alt = "image",
  width = 150,
  height = 150,
  borderRadius = 4,
  padding = 8,
}) {
  const [resolvedUrl, setResolvedUrl] = useState(null);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    let objectUrl = null;
    setHasError(false); // reset error mỗi khi đổi url

    if (!url) {
      setResolvedUrl(null);
    } else if (url instanceof File) {
      objectUrl = URL.createObjectURL(url);
      setResolvedUrl(objectUrl);
    } else {
      setResolvedUrl(url);
    }

    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [url]);

  if (!resolvedUrl) {
    return (
      <Typography variant="caption" color="text.secondary">
        Không có ảnh
      </Typography>
    );
  }

  if (hasError) {
    return (
      <Typography variant="caption" color="error">
        Ảnh không tồn tại
      </Typography>
    );
  }

  return (
    <img
      src={resolvedUrl}
      alt={alt}
      style={{
        height,
        width,
        objectFit: "contain",
        borderRadius,
        padding,
        backgroundSize: "20px 20px",
        backgroundPosition: "0 0, 0 10px, 10px -10px, -10px 0px",
      }}
      onError={() => setHasError(true)}
    />
  );
}

ImageCustom.propTypes = {
  url: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(File)]),
  alt: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  borderRadius: PropTypes.number,
  padding: PropTypes.number,
};

ImageCustom.defaultProps = {
  url: null,
  alt: "image",
  width: 150,
  height: 150,
  borderRadius: 4,
  padding: 8,
};

export default ImageCustom;
